import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ubicaciones',
  templateUrl: './ubicaciones.component.html'
})
export class UbicacionesComponent implements OnInit {
  dataRes = {
    card: { numTarjeta: 0 }
  };
  nuevaSolicitud = false;
  constructor(private router: Router) { }

  ngOnInit() {
  }


  loaderOff($event) {
    this.dataRes = $event
  }
  solicitud(response: boolean) {
    this.nuevaSolicitud = response
  }
}
